import { render, staticRenderFns } from "./app-shell.html?vue&type=template&id=6b33e08a&scoped=true&"
import script from "./app-shell.js?vue&type=script&lang=js&"
export * from "./app-shell.js?vue&type=script&lang=js&"
import style0 from "./app-shell.scss?vue&type=style&index=0&id=6b33e08a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33e08a",
  null
  
)

export default component.exports